module.exports = __webpack_public_path__ + "static/media/Default_Background@3x.711f03b7.jpg";